import { render, staticRenderFns } from "./SubTypeTable.vue?vue&type=template&id=50f74925"
import script from "./SubTypeTable.vue?vue&type=script&lang=js"
export * from "./SubTypeTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports